/**
 * Store email form (MERCH-107, D117). The server returns { configured, version,
 * values, password_set } and never the password; a blank password field keeps
 * the stored one, so it is sent only when the owner typed one.
 */
export const EMAIL_FIELDS = ['host', 'port', 'username', 'from_email', 'from_name'];

/** The form state from the server's read (the password field always starts empty). */
export function emailForm(data) {
  const v = (data && data.values) || {};
  const form = Object.fromEntries(EMAIL_FIELDS.map((k) => [k, v[k] == null ? '' : String(v[k])]));
  if (!form.port) form.port = '587';
  return { ...form, password: '' };
}

/** The save payload: every field, the password only when typed, and the version read. */
export function emailPayload(form, version) {
  const out = Object.fromEntries(EMAIL_FIELDS.map((k) => [k, String(form[k] || '').trim()]));
  if (form.password) out.password = form.password;
  return { ...out, version };
}

/** The hint for a not-mailed result, when the reason is that store email is not set up. */
export const NOT_CONFIGURED = 'MAIL_NOT_CONFIGURED';
